import * as React from 'react'
import { PageHeader, Button} from 'antd'

interface CellLinkProps {
    title: React.ReactNode
}

export const NavigationBar: React.FC<CellLinkProps> = (props) => {
    return <PageHeader onBack={() => window.history.back()} backIcon={<Button type="primary" shape="circle" >{'<'}</Button>} title={props.title } />
}